import API from '../../../../api/baseUrl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../../context';
import { RootState } from '../../../../store';
import { CatalogOrderSet } from './types';
import { getTokens } from '../../../../auth/AuthState';
export interface GetAllCatalogOrderSetsPayload {
  tenancyId: number;
}
export const useGetAllCatalogOrderSets = () => {
  const { startLoading, stopLoading } = useGlobalLoading();
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const [orderSetData, setOrderSetData] = useState<CatalogOrderSet[]>([]);
  const postGetAllCatalogOrderSets = async () => {
    if (!selectedTenancy) return;
    setIsLoading(true);
    try {
      const { id: authorization_token } = await getTokens();
      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };
      startLoading();
      const payload: GetAllCatalogOrderSetsPayload = {
        tenancyId: selectedTenancy.tenancy_id,
      };
      const { data } = await API.post(
        `getAllCatalogOrderSets`,
        { ...payload },
        options,
      );
      setOrderSetData(data.data);
      stopLoading();
    } catch (error: any) {
      console.error('An error occurred during getAllCatalogOrderSets', error);
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in getAllCatalogOrderSets',
      );
    } finally {
      setIsLoading(false);
    }
  };
  return {
    postGetAllCatalogOrderSets,
    errorMessage,
    isLoading,
    orderSetData,
  };
};
